import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { WarrantiesRoutingModule } from './warranties-routing.module';
import { WarrantiesComponent } from './warranties.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { RutPipe } from '../../shared/pipes/rut.pipe'; 

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'; 

// --- CAMBIO AQUÍ: Imports de Material Estándar (Sin 'legacy') ---
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips'; // <-- Este es el vital para los chips
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// Material que ya tenías bien
import { MatExpansionModule } from '@angular/material/expansion'; 
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker'; 

// Componentes y Pipes propios
import { DatePipe } from './pipe/orderDate.pipe';
import { FiltersComponent } from './components/filters/filters.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CdkMenuModule } from '@angular/cdk/menu';
import { DealActionsModule } from '../../features/deal-actions/deal-actions.module';
import { ModalCommentComponent } from './components/modals/modal-comment/modal-comment.component';

@NgModule({
  declarations: [
    WarrantiesComponent, 
    FiltersComponent, 
    DatePipe, 
    ModalCommentComponent
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    RutPipe,
    WarrantiesRoutingModule,
    FontAwesomeModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    CdkMenuModule,
    MatFormFieldModule,
    MatChipsModule,
    MatInputModule,
    MatExpansionModule,
    MatNativeDateModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
    DealActionsModule,
    MatMenuModule,
  ],
})
export class WarrantiesModule {}